// extracted by mini-css-extract-plugin
export var acitonButtons = "_gq-0";
export var additionalIcon = "_gq-f";
export var block = "_gq-1";
export var blockContent = "_gq-7";
export var blockDescription = "_gq-8";
export var blockIcon = "_gq-9";
export var blockTitle = "_gq-6";
export var border = "_gq-a";
export var center = "_gq-l";
export var edge = "_gq-b";
export var edgeLabel = "_gq-c";
export var edgePath = "_gq-d";
export var error = "_gq-e";
export var flowchart = "_gq-g";
export var flowchartContent = "_gq-h";
export var highlighted = "_gq-3";
export var hover = "_gq-4";
export var icon = "_gq-i";
export var left = "_gq-m";
export var navButton = "_gq-j";
export var navButtons = "_gq-k";
export var right = "_gq-n";
export var selected = "_gq-2";
export var small = "_gq-5";